import React, { useRef, useEffect } from 'react';
import { DialogTitle, DialogContent, makeStyles} from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { CloseButton } from './shared/CloseButton';
import { DialogBase } from './DialogBase';
import { QrCode, Barcode } from './Barcode';

interface CodeDialogProps {
  open: boolean;
  type?: 'barcode' | 'qrcode';
  onClose: () => void;
  value: string;
  title?: string | React.ReactNode;
}

const useStyles = makeStyles((theme) =>({
  dialogTitle:{
    width: '100%', 
    boxSizing: 'border-box', 
    display: 'flex', 
    alignItems: 'center', 
    position: 'relative',
  },

  titleText: {
    fontWeight: 600,
    textAlign: 'left',
  },
  
  closeButton:{
    position: 'absolute', 
    right: 8, 
    top: '50%', 
    transform: 'translateY(-50%)',
  },

  content:{
    padding: 24, 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
  },
}));

export const CodeDialog: React.FC<CodeDialogProps> = ({ open, onClose, value, type="barcode", title }) => {
  const classes=useStyles();
  const translate = useTranslate();
  const displayTitle = title || translate('osfc.storage_ui.code_dialog.barcode');
  
  return (
    <DialogBase
      open={open}
      DialogProps={{
        disableEscapeKeyDown: false,
      }}
      DialogContentStyles={{ alignItems: 'stretch' }}
      actions={null}
    >
        <DialogTitle className={classes.dialogTitle}>
          <span className={classes.titleText}>{displayTitle}</span>
          <CloseButton onClick={onClose} className={classes.closeButton}/>
        </DialogTitle>

      <DialogContent className={classes.content}>
        {(type === 'barcode' ? <Barcode value={value} /> : <QrCode value={value}/> )}
        
      </DialogContent>
    </DialogBase>
  );
};

export default CodeDialog;
